import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {AutoplayStopUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayStopUIAct';

/**
 * This State handle situation when autoplay stopped during reels spinning
 */
export class AutoplayStopUIState extends UIState {
    public static readonly ID = 'AutoplayStopUIState';

    public setAct(): void {
        this.act = sequence([
            AutoplayStopUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isAutoplayStop.value;
    }
}